export default __webpack_public_path__ + "static/media/eye-open.faca9c42.png";